import { useAuth0 } from "@auth0/auth0-react";
import { Container, Typography, Box } from "@mui/material";
import { useState, useEffect } from "react";

import AffiliateSelector from "@/components/political/Dashboard/AffiliateSelector";
import { getLocalsFromDashboardFiles } from "@/components/political/Dashboard/dashboardUtils";
import VolunteerDataTable from "@/components/political/Dashboard/VolunteerDataTable";
import SiteIcons from "@/components/SiteIcons/SiteIcons";
import { canViewAllAffiliates } from "@/utils/permissionsHandler";

function VolunteerDataTableContainer({ files, isLoading }) {
  const [selectedLocal, setSelectedLocal] = useState(null);
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [filteredFiles, setFilteredFiles] = useState([]);
  const { user } = useAuth0();

  useEffect(() => {
    setFilteredFiles(files);
  }, [files]);

  useEffect(() => {}, [filteredFiles]);

  useEffect(() => {
    setDropdownOptions(getLocalsFromDashboardFiles(files));
  }, [files]);

  const handleAffiliateSelection = (e, value) => {
    setSelectedLocal(value);
    if (!value) {
      // no local is selected
      setFilteredFiles(files);
    } else {
      const f = files.filter((file) => {
        const parts = file.ada_file.split("/");
        const localId = parts[1];
        return localId === value;
      });
      setFilteredFiles(f);
    }
  };

  return (
    <Container sx={{ marginTop: "7rem" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "end",
          marginBottom: "1rem",
        }}
      >
        <Typography variant="h3">Volunteer Data Files</Typography>
        {canViewAllAffiliates(user) && (
          <AffiliateSelector
            affiliates={dropdownOptions}
            onChange={handleAffiliateSelection}
            selectedLocal={selectedLocal}
          />
        )}
      </Box>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "white",
            height: "150px",
            borderRadius: "4px",
          }}
        >
          <SiteIcons
            iconstring="circular-loader"
            size="2.5rem"
            page="sitewide-loader"
          />
        </Box>
      ) : (
        <VolunteerDataTable files={filteredFiles} />
      )}
    </Container>
  );
}

export default VolunteerDataTableContainer;
